<template>
  <i style="display: block" :class="classes" @click="passMethod('click')">
    <slot></slot>
  </i>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
export default {
  mixins: [themeMixins],
};
</script>
